module.exports = __webpack_public_path__ + "img/symmetry-neutral.74bc5015.svg";